import { actionTypes } from '../../types';

// Action request
export const markActiveInActiveAgencyUser = (payload, callback) => ({
    type: actionTypes.MARK_ACTIVE_INACTIVE_AGENCY_USER_REQUEST,
    payload,
    callback
});

// Action success
export const markActiveInActiveAgencyUserSuccess = (payload) => ({
    type: actionTypes.MARK_ACTIVE_INACTIVE_AGENCY_USER_SUCCESS,
    payload,
});

// Action failure
export const markActiveInActiveAgencyUserFailure = (payload) => ({
    type: actionTypes.MARK_ACTIVE_INACTIVE_AGENCY_USER_FAILURE,
    payload,
});

// Action reset status
export const markActiveInActiveAgencyUserReset = () => ({
    type: actionTypes.MARK_ACTIVE_INACTIVE_AGENCY_USER_RESET,
});

// Action reset all reducer
export const markActiveInActiveAgencyUserResetAll = () => ({
    type: actionTypes.MARK_ACTIVE_INACTIVE_AGENCY_USER_RESET_ALL,
});
